import { ReviewDocumentStatusType } from 'types/prediction';
import baseApi, { API_V1 } from './base';

const assuranceApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    releaseFileLock: build.mutation<any, { fileID: number; fileStatusID: number }>({
      query: ({ fileID, fileStatusID }) => ({
        url: `${API_V1}/Assurance/FileLockRelease`,
        method: 'PUT',
        params: { fileID, fileStatusID }
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error('Failed to release file lock:', arg, error);
        }
      }
    }),
    releaseMultipleFileLocks: build.mutation<any, any>({
      query: (data) => ({
        url: `${API_V1}/Assurance/MulitpleFileLockRelease`,
        method: 'PUT',
        data: data
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error('Failed to update MulitpleFileLockRelease:', arg, error);
        }
      }
    }),
    getAssuranceFileList: build.query<
      any[],
      {
        batchID: number;
        DoctypeID?: any;
        batchTypeID?: any;
        shouldRemoveVerified?: boolean;
      }
    >({
      query: ({ batchID, batchTypeID = 1, DoctypeID }) => ({
        url: `${API_V1}/Assurance/GetAssuranceListDetail`,
        params: { BatchID: batchID, batchTypeID: batchTypeID, DoctypeID: DoctypeID }
      }),

      transformResponse: (responseData: { data: { fileList: any[] } }, _meta, arg) => {
        let data = (responseData?.data?.fileList || []).map((file) => ({
          ...file,
          statusName: String(file.statusName).replaceAll(' ', '').toUpperCase(),
          parentBatchID: String(arg.batchID)
        }));

        if (arg.shouldRemoveVerified) {
          data = data.filter(({ statusName }) => statusName !== ReviewDocumentStatusType.QCVERIFIED);
        }
        return data;
      }
    }),

    getBatchList: build.query<any[], { docTypeID: number; screenType: string }>({
      query: ({ docTypeID, screenType }) => ({
        url: `${API_V1}/Assurance/GetBatchDetails`,
        params: { DocTypeId: docTypeID, screenType: screenType }
      }),
      transformResponse: (responseData: { data: any[] }) =>
        responseData.data
          ? responseData.data.map((row) => ({ ...row, batchStatus: String(row.batchStatus).replaceAll(' ', '').toUpperCase() }))
          : []
    }),
    getAssuranceBatchList: build.query<any[], { docTypeID: number; batchTypeId: number }>({
      query: ({ docTypeID, batchTypeId }) => ({
        url: `${API_V1}/Assurance/GetAssuranceBatchDetails`,
        params: { DocTypeId: docTypeID, BatchTypeID: batchTypeId }
      }),
      transformResponse: (responseData: { data: any[] }) =>
        responseData.data
          ? responseData.data.map((row) => ({ ...row, batchStatus: String(row.batchStatus).replaceAll(' ', '').toUpperCase() }))
          : []
    }),

    getAssuranceProcesses: build.query<any[], { BatchTypeID: number }>({
      query: ({ BatchTypeID }) => ({
        url: `${API_V1}/Assurance/GetAssuranceProcessDetails`,
        params: { BatchTypeID }
      })
    }),
    getAssuranceDocumentTypes: build.query<any[], { processId: number; BatchTypeID: any }>({
      query: ({ processId, BatchTypeID }) => ({
        url: `${API_V1}/Assurance/GetAssuranceDocumentType`,
        params: { processId, BatchTypeID }
      }),
      transformResponse: (responseData: { data: any[] }) => responseData.data || []
    }),
    getAssuranceSearchLookupData: build.query<any[], { fieldId: number; fieldModeId: number; searchText: string }>({
      query: ({ fieldId, fieldModeId, searchText }) => ({
        url: `${API_V1}/Assurance/SearchLookupData`,
        params: { fieldId, fieldModeId, searchText }
      }),
      transformResponse: (responseData: { data: any[] }) => responseData.data || []
    }),
    getassuranceFileReport: build.mutation<{ blob: Blob; fileName: string }, { fileid: any; batchid: any; exportType: string }>({
      query: ({ fileid, batchid, exportType }) => ({
        url: `${API_V1}/Assurance/ExportData`,
        method: 'GET',
        params: { fileid, batchid, ExportType: exportType },
        responseType: 'blob'
      }),
      transformResponse: (res: Blob, headers) => {
        let fileName = 'file';
        const contentDisposition = (headers as any)?.['content-disposition'];
        if (contentDisposition) {
          const values = contentDisposition.split(';');
          const filenamePart = values.find((value: any) => value.trim().startsWith('filename='));

          if (filenamePart) {
            fileName = filenamePart.split('filename=')[1].replace(/"/g, '').trim();
          }
        }
        if (!fileName.includes('.')) {
          fileName += '.csv'; // Default extension if none is provided
        }
        return { blob: res, fileName };
      }
    })
  })
});

export const {
  useReleaseFileLockMutation,
  useGetBatchListQuery,
  useReleaseMultipleFileLocksMutation,
  useGetAssuranceBatchListQuery,
  useGetAssuranceFileListQuery,
  useLazyGetAssuranceFileListQuery,
  useGetAssuranceProcessesQuery,
  useGetAssuranceDocumentTypesQuery,
  useGetassuranceFileReportMutation,
  useLazyGetAssuranceSearchLookupDataQuery
} = assuranceApi;
export default assuranceApi;
